const AcquistiHome = () => import("./AcquistiHome")
const Lamiera = () => import("./Lamiera")
const Tubi = () => import("./Tubi")
const ContoLavoro = () => import("./ContoLavoro")
const ContoLavoroListino = () => import("./ContoLavoroListino")
const Ricevimenti = () => import("./Ricevimenti")
const PurchaseWorkspace = () => import("./PurchaseWorkspace")

const pages = [
    {
        path: '/acquisti/',
        name: 'acquisti-home',
        meta: {menu: 'acquisti', title: 'Acquisti'},
        component: AcquistiHome,
    },
    {
        path: '/acquisti/lamiera/',
        name: 'acquisti-lamiera',
        meta: {menu: 'acquisti', title: 'Acquisti Lamiera'},
        component: Lamiera,

    },
    {
        path: '/acquisti/tubi/',
        name: 'acquisti-tubi',
        meta: {menu: 'acquisti', title: 'Acquisti Tubi'},
        component: Tubi,

    },
    {
        path: '/acquisti/contolavoro/',
        name: 'acquisti-contolavoro',
        meta: {menu: 'acquisti', title: 'Acquisti Conto Lavoro'},
        component: ContoLavoro,

    }, {
        path: '/acquisti/contolavorolistino/:fornitore/:nome/',
        name: 'acquisti-contolavorolistino',
        meta: {menu: 'acquisti', title: 'Acquisti Conto Lavoro Listino'},
        component: ContoLavoroListino,

    },
    {
        path: '/acquisti/ricevimenti/:fornitore?',
        name: 'acquisti-ricevimenti',
        meta: {menu: 'acquisti', title: 'Acquisti Ricevimenti'},
        component: Ricevimenti,

    },
]

export default [{
    path: '/acquisti/',
    component: PurchaseWorkspace,
    meta: { menu: 'acquisti', hideSubMenu: true },
    children: pages.map(page => ({
        ...page,
        path: page.path,
        meta: { ...page.meta, hideSubMenu: true },
    })),
}]
